import { routes } from "Projects/config/routes";
import SetupRoute from "Projects/routes/Setup";
import DeadlinesWrapper from "Projects/routes/DeadlinesWrapper";
import GuidanceWrapper from "Projects/routes/GuidanceWrapper";
import ProgressRoute from "Projects/routes/Progress";
import CreateProject from "Projects/routes/CreateProject";
import StudentPortfolios from "Projects/routes/StudentPortfolios";
import ProjectGroup from "./components";
import ServiceAsActionInsights from "Projects/routes/ServiceAsActionInsights";
import PortfolioInsights from "Projects/routes/PortfolioInsights";
import OverviewRoute from "Projects/routes/Overview";
import StimuliSetupRoute from "Projects/routes/StimuliSetup";
import ExperiencesWrapper from "Projects/routes/ExperiencesWrapper";
import GradebookAssessmentRoute from "Projects/routes/Gradebook/routes/Assessment";
import CasInsights from "Projects/routes/CasInsights";
import Bin from "../Bin";

const {
  projectGroup: { path },
} = routes;

export default store => {
  return {
    path,
    component: ProjectGroup,
    childRoutes: [
      Bin(store),
      SetupRoute(store),
      DeadlinesWrapper(store),
      GuidanceWrapper(store),
      ProgressRoute(store),
      CreateProject(store),
      ServiceAsActionInsights(store),
      StudentPortfolios(store),
      OverviewRoute(store),
      StimuliSetupRoute(store),
      PortfolioInsights(store),
      CasInsights(store),
      ExperiencesWrapper(store),
      GradebookAssessmentRoute(store),
    ],
  };
};
